import { Component, Input } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-generic-create-button',
  imports: [MatIconModule, MatButtonModule],
  templateUrl: './generic-create-button.component.html',
  styleUrl: './generic-create-button.component.css'
})
export class GenericCreateButtonComponent {
  @Input({required:true}) nameButton:string = "";

}
